import styled from "@emotion/styled";
import { Container, Grid, Link} from "@mui/material";
import React from "react";
import { Image } from "../../../../Styles/style";
import SectionsHeading from "../../SectionsHeading";
import Paragraph from "../../Paragraph";
import image1 from "../../../../../assets/Images/logo.png";
import CustomButton from "../../CustomBtn";

const ContinerWraper = styled(Container)`
  background-color: ${(props) => props.theme.bgPrimary};
  position: relative;
  height: auto;
  width: 100%;
  padding: 70px 0 0 !important;
`;



const Text = styled.input`
  background: transparent !important;
  border: 1px solid #ffffff64;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;
  color: #fff;
  width: 100%;

  font-family: PoppinsR;
  :focus {
    outline: none;
    border-color: #fff;
  }
`;
const Textarea = styled.textarea`
  background: transparent !important;
  border: 1px solid #ffffff64;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;
  color: #fff;
  font-family: PoppinsR;
  width: 100%;
  :focus {
    outline: none;
    border-color: #fff;
  }
`;
const Div = styled(Grid)`
  display: flex;
  align-items: center;
  flex-direction: column;
  row-gap: 10px !important;
  @media(max-width:599px){
    align-items: start;
  }
`;

const Footer = () => {
  return (
    <ContinerWraper maxWidth="xxl" id="howitworks">
      <Container>
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "center",
            rowGap: "20px",
            zIndex: "1",
            columnGap: "30px",
            padding: "0 0 70px",
          }}
        >
          <Grid item xs={12} sm={3}>
            <Image mw="150px" src={image1} />
            <Paragraph ta="left" fs="14px">
              Access your SHIA's value today, without losing out on tomorrow's
              gains!
            </Paragraph>
          </Grid>
          <Div
            item
            xs={12}
            sm={3}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                rowGap: "10px !important",
              }}
            >
              <SectionsHeading
                ta="left"
                fs="16px"
                fs599="16px"
                color="#FC9C00 !important"
              >
                Quick Links
              </SectionsHeading>
              <Link sx={{ textDecoration: "none" }} href="#home">
                <SectionsHeading
                  ta="left"
                  fs="14px"
                  fs599="14px"
                  p="5px 0"
                  p599="5px 0"
                  p899="5px 0"
                  fm="PoppinsR"
                >
                  Home
                </SectionsHeading>
              </Link>
              <Link sx={{ textDecoration: "none" }} href="#stats">
                <SectionsHeading
                  ta="left"
                  fs="14px"
                  fs599="14px"
                  p="5px 0"
                  p599="5px 0"
                  p899="5px 0"
                  fm="PoppinsR"
                >
                  Stats
                </SectionsHeading>
              </Link>
              <Link sx={{ textDecoration: "none" }} href="#howitwork">
                <SectionsHeading
                  ta="left"
                  fs="14px"
                  fs599="14px"
                  p="5px 0"
                  p599="5px 0"
                  p899="5px 0"
                  fm="PoppinsR"
                >
                  How It Works
                </SectionsHeading>
              </Link>
              <Link sx={{ textDecoration: "none" }} href="#tokenomics">
                <SectionsHeading
                  ta="left"
                  fs="14px"
                  fs599="14px"
                  p="5px 0"
                  p599="5px 0"
                  p899="5px 0"
                  fm="PoppinsR"
                >
                  SVAULT Token
                </SectionsHeading>
              </Link>
              <Link sx={{ textDecoration: "none" }} href="#document">
                <SectionsHeading
                  ta="left"
                  fs="14px"
                  fs599="14px"
                  p="5px 0"
                  p599="5px 0"
                  p899="5px 0"
                  fm="PoppinsR"
                >
                  Documents
                </SectionsHeading>
              </Link>
              <Link sx={{ textDecoration: "none" }} href="#faq">
                <SectionsHeading
                  ta="left"
                  fs="14px"
                  fs599="14px"
                  p="5px 0"
                  p599="5px 0"
                  p899="5px 0"
                  fm="PoppinsR"
                >
                  FAQ
                </SectionsHeading>
              </Link>
            </div>
          </Div>
          <Grid item xs={12} sm={4}>
            <SectionsHeading
              ta="left"
              fs="16px"
              fs599="16px"
              color="#FC9C00 !important"
            >
              Contact Us
            </SectionsHeading>
            <Text placeholder="Email" />
            <Textarea placeholder="Enter message here.." />
            <CustomButton
              sx={{ width: "100% !important" }}
              bgc="#53616f"
              c="#fff"
              hbgc="#fff"
              hc="#53616f"
            >
              Send
            </CustomButton>
          </Grid>
        </Grid>
      </Container>
      <div style={{ background: "#FC9C00", width: "100%" }}>
        <SectionsHeading
          ta="center"
          fs="12px"
          fs599="12px"
          p="5px 0"
          p599="5px 0"
          p899="5px 0"
          fm="PoppinsR"
          color="#000"
        >
          © 2023 SHIA LENDING on the Ethereum Network. All rights reserved.
        </SectionsHeading>
      </div>
    </ContinerWraper>
  );
};

export default Footer;
